import { useContext } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Card, CardBody, CardHeader, Col, Row, Button } from "reactstrap";
import FormInput from "../../components/FormInput";
import { CompanyContext } from "../../contexts/CompanyContext";
import { toast } from "react-hot-toast";

const validationSchema = Yup.object().shape({
  oldPassword: Yup.string().required("Old password is required."),
  newPassword: Yup.string().required("New password is required.").min(6, "Minimum 6 characters."),
  confirmPassword: Yup.string()
    .required("Confirm password is required.")
    .oneOf([Yup.ref("newPassword")], "Passwords do not match."),
});

export default function Profile() {
  const { selectedCompany }: any = useContext(CompanyContext);

  let rememberedUsername = "";
  const rememberedLogin = localStorage.getItem("remembered-login");
  if (rememberedLogin) {
    try {
      rememberedUsername = JSON.parse(rememberedLogin)?.username || "";
    } catch {
      rememberedUsername = "";
    }
  }

  const displayCompanyName = selectedCompany?.name || "-";
  const displayUsername = rememberedUsername || "-";

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2 page-title-row'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Profile</h1>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-auto'>
        <Card className='h-100 p-3 w-100'>
          <Row className='g-3'>
            <Col md={12}>
              <Card className='border-0 shadow-sm'>
                <CardHeader className='bg-white border-bottom'>
                  <h5 className='m-0'>Account Details</h5>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md={6}>
                      <FormInput
                        label='Username'
                        name='username'
                        value={displayUsername}
                        readOnly
                      />
                    </Col>
                    <Col md={6}>
                      <FormInput
                        label='Company'
                        name='company'
                        value={displayCompanyName}
                        readOnly
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col md={12}>
              <Card className='border-0 shadow-sm'>
                <CardHeader className='bg-white border-bottom'>
                  <h5 className='m-0'>Change Password</h5>
                </CardHeader>
                <CardBody>
                  <Formik
                    initialValues={{
                      oldPassword: "",
                      newPassword: "",
                      confirmPassword: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(_, { resetForm }) => {
                      toast.success("Password change request submitted.");
                      resetForm();
                    }}
                  >
                    {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                      <>
                        <Row>
                          <Col md={4}>
                            <FormInput
                              label='Old Password'
                              name='oldPassword'
                              type='password'
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.oldPassword}
                              error={errors.oldPassword}
                              touched={touched.oldPassword}
                            />
                          </Col>
                          <Col md={4}>
                            <FormInput
                              label='New Password'
                              name='newPassword'
                              type='password'
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.newPassword}
                              error={errors.newPassword}
                              touched={touched.newPassword}
                            />
                          </Col>
                          <Col md={4}>
                            <FormInput
                              label='Confirm New Password'
                              name='confirmPassword'
                              type='password'
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values.confirmPassword}
                              error={errors.confirmPassword}
                              touched={touched.confirmPassword}
                            />
                          </Col>
                        </Row>

                        <div className='d-flex justify-content-end'>
                          <Button size='sm' color='primary' onClick={() => handleSubmit()}>
                            Update Password
                          </Button>
                        </div>
                      </>
                    )}
                  </Formik>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
}
